


























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class NavigationBar extends Vue {
  ifScroll = false;
  mounted() {
    window.addEventListener(
      "scroll",
      () => (this.ifScroll = window.scrollY > 450)
    );
  }
}
